import React from 'react'
import Layout from './Layout'
import { useProps } from './useProps'

export const SurveySchedules = (params: { surveyId: App.Survey['id'] }) => <Layout {...useProps(params)} />
